
import {
  Component, Vue, Prop,
} from 'nuxt-property-decorator'
import BaseIcon from '../base/BaseIcon.vue'
import BaseLink from '../base/BaseLink.vue'

@Component({
  name: 'GptConversationStarters',
  components: {
    BaseLink,
    BaseIcon,
  },
})
export default class GptConversationStarters extends Vue {
  @Prop({ default: () => [] }) conversationStarters! : string[]
}
